var React = require('react');

function CaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 5.5L3 10.5L13 10.5L8 5.5Z","fill":"currentColor"}));
}

CaretUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CaretUp;

CaretUp.default = CaretUp;
